import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const url = `https://api.avdhaan.grampower.com/${process.env.REACT_APP_OTHER_MODULES_URL}`;
// Define a service using a base URL and expected endpoints
export const gisApi = createApi({
  reducerPath: 'gisApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getGISFilteredApplyAssetsTillDTR: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/project/filter/data`,
        params: params
      }),
      providesTags: ['gisFilterApplyAssetsTillDtr']
    }),
    getGISFilteredApplyAssetsTillMeter: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/site/filter/data`,
        params: params
      })
    }),
    getGISAssetsMeterLevel: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/site/data`,
        params: params
      })
    }),
    getGISAssetsTillDTR: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/project/data`,
        params: params
      })
    }),
    getGISHoveringToolTipData: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/asset/count/data`,
        params: params
      })
    }),
    getGISAssetFilterData: builder.query({
      query: (params) => ({
        url: `${url}/api/v1/get/gis/filter/list`,
        params: params
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetGISAssetsMeterLevelQuery,
  useLazyGetGISFilteredApplyAssetsTillDTRQuery,
  useLazyGetGISFilteredApplyAssetsTillMeterQuery,
  useLazyGetGISAssetsTillDTRQuery,
  useLazyGetGISHoveringToolTipDataQuery,
  useLazyGetGISAssetFilterDataQuery
} = gisApi;
